import { useState } from 'react';
import PremiumIcon from '../../assets/premium.png';
import { Alert, AlertActions, AlertDescription, AlertTitle } from '../../catalyst/alert';
import { Button } from '../../catalyst/button';
import { Link } from '../../catalyst/link';
import { Strong, Text } from '../../catalyst/text';
import config from '../../config';

export default function PremiumPopupForTransfer (props) {
  const [open, setOpen] = useState(props.showPremiumOptions);

  const handleClose = () => {
    setOpen(false)
    console.log("close")
    props.setShowPremiumOptions(false);
  };

  return (
<>

    <Alert open={open} onClose={() => {props.setShowPremiumOptions(false);}}>
        <AlertTitle>Upgrade Premium</AlertTitle>
        <AlertDescription className="text-center">
        <div className="flex flex-col items-center space-y-4">
          <img
            src={PremiumIcon} // Replace with your image URL
            alt="Diamond"
            style={{ width: '100px', height: '100px' }}
          />
          <Text className="text-center">
            You tried to transfer <Strong>{props.triedTracksCount} songs</Strong>. Free transfer is limited to <Strong>99 songs</Strong>. 
          </Text>
          <Text className="text-center">
            Go premium just for <Strong>$1.79</Strong> for unlimited transfer and help us to with building a better product for you.  
          </Text>
        </div>
        </AlertDescription>
        <AlertActions>
          <Button plain onClick={handleClose}>
            Cancel
          </Button>
          <Link href={config.premiumPath}><Button onClick={() => {}}>Go Premium for $1.79 !!</Button></Link>
        </AlertActions>
      </Alert>
    </>


  );
};
